import React, { useEffect, useState } from 'react';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css';
import { useDispatch, useSelector } from 'react-redux';
import { ListPage } from '../../commonComponents/ListPage';
import { fetchLicensesV2 } from '../../../actions/licensesAction';
import { createLoadingSelector } from '../../../apis/selectors';
import { Table } from '../../commonComponents/Table/Table';
import {
  licensesColumnsV2,
  licensesConditionalRowStylesV2,
} from '../../commonComponents/jobs-column';
import { Filters } from './Filters';
import { handleFilterChange } from '../../commonComponents/Table/utils';

const ROWS_PER_PAGE = 15;

const getDefaultFilterV2 = (searchParams) => ({
  profession: searchParams.profession || '',
  status: searchParams.status || '',
  state: searchParams.state || '',
  credentialType: searchParams.credential_type || '',
  expiresSoon: searchParams.expiresSoon || '',
  page: searchParams.page || 1,
  sortField: searchParams.sortField || 'created_at',
  sortOrder: searchParams.sortOrder || 'desc',
});

const actionsV2 = ['GET_CREDENTIALS_V2'];
const loadingSelectorV2 = createLoadingSelector(actionsV2);

export const Licenses = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => loadingSelectorV2(state));
  const licenses = useSelector((state) => state.license.credentialsV2);
  const searchParams = useSelector((state) => state.license.searchParams);
  const totalLicenses = useSelector((state) => state.license.totalCredentialsV2);
  const totalPages = Math.ceil(totalLicenses / ROWS_PER_PAGE);

  const [filter, setFilter] = useState(() => getDefaultFilterV2(searchParams));

  const getUserUrl = (userId, userType) => `/user/${userType.toLowerCase()}/${userId}`;

  const getColumn = () => licensesColumnsV2({ getUserUrl });

  const handleTableChange = (page) => {
    setFilter((prevState) => ({ ...prevState, page }));
  };

  const handleOnSort = (selectedColumn, sortDirection) => {
    const sortObj = {
      page: filter.page,
      sortField: selectedColumn.sortField,
      sortOrder: sortDirection,
    };

    setFilter((prevState) => ({
      ...prevState,
      ...sortObj,
    }));
  };

  useEffect(() => {
    dispatch(fetchLicensesV2({ ...filter }));
  }, [dispatch, filter]);

  return (
    <ListPage
      title="Licenses"
      isLoading={isLoading}
      total={totalLicenses || 0}
      filters={(
        <Filters
          filter={filter}
          handleFilterChange={(type, value) => handleFilterChange(type, value, setFilter)}
        />
      )}
    >
      <Table
        keyField="_rowKey"
        initialPage={filter.page}
        columns={getColumn()}
        data={licenses}
        noDataComponent="There are no Licenses"
        isLoading={isLoading}
        totalPages={totalPages}
        paginationPerPage={ROWS_PER_PAGE}
        paginationTotalRows={totalLicenses}
        showTotal={false}
        onSort={handleOnSort}
        onPageChange={handleTableChange}
        conditionalRowStyles={licensesConditionalRowStylesV2}
      />
    </ListPage>
  );
};
